import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntroDecorativeStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 454,
	height: 455,
	viewBox: "0 0 454 455",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M453.96 89.67C293.46 224.38 284.65 260.18 364.33 454.01C229.62 293.49 193.81 284.67 0 364.34C160.5 229.63 169.31 193.83 89.63 0C224.34 160.52 260.15 169.34 453.96 89.67Z",
		fill: "#7A7EED"
	})
});
export default SvgIntroDecorativeStar;
